import axios from 'axios';
import { UserDto } from './usersService';

// מפקח מכירות חלקי עם הנציגים המשויכים אליו
export interface PartialSupervisorDto {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  isActive: boolean;
  groupName?: string | null;
  salesReps: UserDto[];
  createdAt: string;
  updatedAt: string;
  lastLoginAt?: string | null;
}

export interface CreatePartialSupervisorDto {
  fullName: string;
  email: string;
  phone: string;
  password: string;
  groupName?: string | null;
  salesRepIds: number[];
}

export const partialSupervisorsApi = {
  getAll: async (): Promise<PartialSupervisorDto[]> => {
    const response = await axios.get('/partial-supervisors');
    return response.data;
  },

  getById: async (id: number): Promise<PartialSupervisorDto> => {
    const response = await axios.get(`/partial-supervisors/${id}`);
    return response.data;
  },

  create: async (body: CreatePartialSupervisorDto): Promise<PartialSupervisorDto> => {
    const response = await axios.post('/partial-supervisors', body);
    return response.data;
  },

  setSalesReps: async (
    id: number,
    salesRepIds: number[],
    groupName?: string | null
  ): Promise<PartialSupervisorDto> => {
    const response = await axios.put(`/partial-supervisors/${id}/sales-reps`, {
      salesRepIds,
      groupName,
    });
    return response.data;
  },

  // ניהול מצד הנציג — המפקחים החלקיים שאחראים על נציג נתון
  getSupervisorsForRep: async (repId: number): Promise<PartialSupervisorDto[]> => {
    const response = await axios.get(`/partial-supervisors/sales-rep/${repId}/supervisors`);
    return response.data;
  },

  setSupervisorsForRep: async (repId: number, supervisorIds: number[]): Promise<PartialSupervisorDto[]> => {
    const response = await axios.put(`/partial-supervisors/sales-rep/${repId}/supervisors`, {
      supervisorIds,
    });
    return response.data;
  },
};
